import React from "react";
import { Link } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { MessageSquare, Lock, Hash } from "lucide-react";
import DashboardLayout from "@/components/layout/DashboardLayout";
import { Loading } from "@/components/shared";
import { TierBadge } from "@/components/shared";
import api from "@/lib/api";

export default function Community() {
  const { data, isLoading } = useQuery({ queryKey: ["spaces"], queryFn: async () => (await api.get("/community/spaces")).data });

  return (
    <DashboardLayout>
      <div className="mb-8">
        <h1 className="font-heading text-3xl font-bold tracking-tight text-navy">CEO Community</h1>
        <p className="mt-2 text-slate-600">Focused spaces to get feedback, share wins and stay accountable.</p>
      </div>
      {isLoading ? <Loading /> : (
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {data.map((s) => (
            <Link key={s.slug} to={`/community/${s.slug}`} data-testid={`space-${s.slug}`}
              className="group relative flex flex-col rounded-xl border border-slate-200 bg-white p-5 transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_12px_40px_rgb(0,0,0,0.06)]">
              <div className="flex items-center justify-between">
                <div className="inline-flex h-10 w-10 items-center justify-center rounded-lg bg-navy/5 text-navy"><Hash className="h-5 w-5" strokeWidth={1.75} /></div>
                {s.locked ? <span className="inline-flex items-center gap-1 text-xs font-semibold text-slate-400"><Lock className="h-3.5 w-3.5" /> <TierBadge tier={s.membership_requirement} /></span> : <TierBadge tier={s.membership_requirement} />}
              </div>
              <h3 className="mt-4 font-heading text-lg font-semibold text-navy group-hover:text-emerald">{s.name}</h3>
              <p className="mt-2 flex items-center gap-1.5 text-sm text-slate-500"><MessageSquare className="h-4 w-4" /> {s.post_count} posts</p>
            </Link>
          ))}
        </div>
      )}
    </DashboardLayout>
  );
}
